// @flow
import { createReducer } from 'actions';
import type { ZuzuAction } from 'types';

import { LOAD_ASSIGNMENTS } from 'actions/assignments';
import { LOGOUT } from 'actions/auth';

type State = {
  all: Array<Object>,
  loading: boolean,
  error: ?string,
};

const initialState: State = {
  all: [],
  loading: false,
  error: null,
};

export default createReducer(
  initialState,
  {
    [LOAD_ASSIGNMENTS]: (state: State, action) => {
      if (!action.meta.done) {
        return {
          ...state,
          loading: true,
          error: null,
        };
      }
      if (action.meta.done && !action.meta.error && action.payload) {
        return {
          ...state,
          all: [...action.payload.assignments],
          loading: false,
          error: null,
        };
      }
      return state;
    },
    [LOGOUT]: () => {
      return { ...initialState };
    },
  },
  (state: State, action: ZuzuAction) => {
    return {
      ...state,
      error: action.payload,
    };
  }
);



// WEBPACK FOOTER //
// ./src/redux/reducers/assignments.js